import { render, staticRenderFns } from "./edit-medicament.html?vue&type=template&id=24a8c5a6&scoped=true&external"
import script from "./edit-medicament.js?vue&type=script&lang=js&external"
export * from "./edit-medicament.js?vue&type=script&lang=js&external"
import style0 from "./edit-medicament.scss?vue&type=style&index=0&id=24a8c5a6&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a8c5a6",
  null
  
)

export default component.exports